import { render, staticRenderFns } from "./babylonViewer.vue?vue&type=template&id=972470e8"
import script from "./babylonViewer.vue?vue&type=script&lang=js"
export * from "./babylonViewer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports